export default function ChessIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect x="4" y="4" width="56" height="56" rx="8" fill="#B98A5E" />
      <path d="M4 4h14v14H4zM32 4h14v14H32zM18 18h14v14H18zM46 18h14v14H46zM4 32h14v14H4zM32 32h14v14H32zM18 46h14v14H18zM46 46h14v14H46z" fill="#F0DCB4" />
      {/* knight */}
      <path
        d="M20 54h22v-5H20zM23 49c0-7 6-10 6-15-3 1-6 0-8 3l-4-3c2-7 6-13 14-15l1-5 4 5c6 3 8 11 6 30z"
        fill="#2F8BFF"
        stroke="#0B2A52"
        strokeWidth="2.5"
        strokeLinejoin="round"
      />
      <circle cx="30" cy="24" r="2" fill="#0B2A52" />
      {/* pawn */}
      <path d="M44 56h14v-4H44zM46 52l2-9h6l2 9zM51 43a4 4 0 1 0 0-8 4 4 0 0 0 0 8z" fill="#FF8A1F" stroke="#4A2104" strokeWidth="2" strokeLinejoin="round" />
    </svg>
  );
}
